<h3 class="title-divider mb-2">{{ heading | translate }}</h3>

<cap-form-row column-classes="col-md-1,col-md-1">
  <cap-form-control column-classes="col-md-2,col-md-4" invalidKey="EingabeMussValidesDatumSeinBeispiel" labelKey="ZeitraumVon">
    <cap-datepicker
      (ngModelChange)="model && (model.datumVon = $event)"
      [disabled]="disabled"
      [ngModel]="model && model.datumVon"
      name="datumVon"></cap-datepicker>
  </cap-form-control>
</cap-form-row>
<cap-form-row column-classes="col-md-1,col-md-1">
  <cap-form-control column-classes="col-md-2,col-md-4" invalidKey="EingabeMussValidesDatumSeinBeispiel" labelKey="ZeitraumBis">
    <input [ngModel]="datumBis | translate" name="datumBis" readonly type="text" />
  </cap-form-control>
</cap-form-row>
